import { Link } from "react-router-dom";
import { TOOLS } from "../data/tools";
import { ToolCard } from "../components/ToolCard";
import { Seo } from "../components/Seo";

const PANELS = [
    {
        label: "Criptografia Local",
        img: "https://images.unsplash.com/photo-1614064548237-096f735f344f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxjeWJlciUyMHNlY3VyaXR5JTIwZGF0YSUyMGdyZWVufGVufDB8fHx8MTc5MjY5MTE3M3ww&ixlib=rb-4.1.0&q=85",
        alt: "Cadeado sobre notebook com trilhas de luz, representando criptografia",
    },
    {
        label: "Renderização Instantânea",
        img: "https://images.pexels.com/photos/28494632/pexels-photo-28494632.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        alt: "Formas geométricas neon abstratas em fundo azul",
    },
    {
        label: "Exclusão 60 Minutos",
        img: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxjeWJlciUyMHNlY3VyaXR5JTIwZGF0YSUyMGdyZWVufGVufDB8fHx8MTc5MjY5MTE3M3ww&ixlib=rb-4.1.0&q=85",
        alt: "Código verde em tela escura, representando exclusão programada",
    },
    {
        label: "Conformidade LGPD",
        img: "https://images.pexels.com/photos/38701975/pexels-photo-38701975.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        alt: "Letras coloridas recortadas formando as palavras segurança cibernética",
    },
    {
        label: "Suporte Mobile",
        img: "https://images.pexels.com/photos/17489160/pexels-photo-17489160.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        alt: "Racks de servidores iluminados em data center moderno",
    },
    {
        label: "Download Direto",
        img: "https://images.pexels.com/photos/30547584/pexels-photo-30547584.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        alt: "Paisagem digital futurista com luzes brilhantes",
    },
];

const FAQ_HOME = [
    {
        q: "É necessário criar conta?",
        a: "Não. Todas as ferramentas da primeira versão funcionam imediatamente, sem login ou cadastro.",
    },
    {
        q: "Os arquivos ficam salvos?",
        a: "Não. Eles são apagados automaticamente e de forma definitiva em até 60 minutos após o envio.",
    },
];

export default function HomePage() {
    return (
        <main id="inicio">
            <Seo
                title="ScorpionPDF — Juntar, dividir e comprimir PDF grátis, sem cadastro"
                description="Ferramentas de PDF gratuitas e privadas: junte, divida, comprima, gire e converta PDFs sem cadastro. Arquivos excluídos automaticamente em até 60 minutos."
            />

            {/* HERO */}
            <section className="border-b-2 border-black bg-[#F0F9FF] py-16 md:py-24 px-6">
                <div className="max-w-6xl mx-auto">
                    <div className="inline-block border-2 border-black bg-white p-2 hard-shadow-sm mb-6">
                        <img
                            src="/logo-scorpionpdf.png"
                            alt="Logo ScorpionPDF"
                            className="block w-16 h-16 sm:w-20 sm:h-20 object-contain"
                            width="80"
                            height="80"
                            data-testid="hero-logo"
                        />
                    </div>
                    <div className="inline-flex flex-wrap items-center gap-2 px-3 py-1 bg-black text-[#22D3EE] font-mono-tag text-xs font-bold uppercase mb-6">
                        <span>● Zero cadastro</span>
                        <span>● Auto-exclusão em 60 min</span>
                        <span>● 100% Brasil</span>
                    </div>
                    <h1 className="font-poster text-5xl sm:text-7xl md:text-8xl text-black leading-[0.9]">
                        <span className="ln"><span>Ferramentas PDF instantâneas</span></span>
                        <span className="ln"><span>e totalmente privadas.</span></span>
                    </h1>
                    <p className="mt-6 text-base md:text-xl font-medium text-gray-800 max-w-2xl">
                        Junte, comprima e edite PDFs sem anúncios invasivos. Exclusão de arquivos garantida em até 60 minutos.
                    </p>
                    <div className="mt-10 border-2 border-black p-4 bg-white hard-shadow">
                        <Link
                            to="/ferramentas"
                            data-testid="hero-catalog-cta"
                            className="block border-2 border-dashed border-gray-400 hover:border-black p-8 text-center transition-colors group"
                        >
                            <svg className="w-10 h-10 text-black mb-3 mx-auto" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                                <rect x="4" y="4" width="16" height="16" rx="2" />
                                <path d="M12 9v6m-3-3h6" />
                            </svg>
                            <span className="font-poster text-2xl text-black block">ESCOLHA UMA FERRAMENTA E COMECE</span>
                            <span className="font-mono-tag text-xs text-gray-500 mt-1 block">
                                Processamento seguro em conformidade com a LGPD
                            </span>
                            <span className="inline-block mt-4 px-6 py-2.5 bg-black text-white group-hover:bg-[#0284C7] font-mono-tag text-xs font-bold uppercase transition-colors">
                                Explorar Catálogo
                            </span>
                        </Link>
                    </div>
                </div>
            </section>

            {/* MARQUEE */}
            <div className="py-3 bg-black text-[#22D3EE] overflow-hidden border-b-2 border-black" aria-hidden="true">
                <div className="mq-poster flex items-center gap-8 font-poster text-xl tracking-wider">
                    <span>JUNTAR PDF ✦ COMPRIMIR PDF ✦ DIVIDIR PDF ✦ GIRAR PÁGINAS ✦ CONVERTER IMAGENS ✦ EXCLUSÃO 60 MINUTOS ✦&nbsp;</span>
                    <span>JUNTAR PDF ✦ COMPRIMIR PDF ✦ DIVIDIR PDF ✦ GIRAR PÁGINAS ✦ CONVERTER IMAGENS ✦ EXCLUSÃO 60 MINUTOS ✦&nbsp;</span>
                </div>
            </div>

            {/* GRID DE FERRAMENTAS */}
            <section id="grade" className="py-20 px-6 max-w-6xl mx-auto">
                <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
                    <div>
                        <span className="font-mono-tag text-xs font-bold text-[#0284C7] uppercase">Coleção completa</span>
                        <h2 className="font-poster text-4xl text-black mt-1">Ferramentas essenciais</h2>
                    </div>
                    <span className="font-mono-tag text-xs text-gray-600">10 operações grátis por dia · sem cadastro · até 25 MB por arquivo</span>
                </div>

                {/* destaque: fluxo combinado */}
                <Link
                    to="/fluxo"
                    data-testid="home-flow-cta"
                    className="block border-2 border-black bg-black text-white p-6 mb-6 hard-shadow hover:bg-[#0284C7] transition-colors group"
                >
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                        <div>
                            <span className="font-mono-tag text-[11px] font-bold uppercase text-[#22D3EE]">Novo · Módulo avançado</span>
                            <h3 className="font-poster text-2xl md:text-3xl mt-1">Combinar ferramentas em um fluxo único</h3>
                            <p className="text-sm text-gray-300 mt-1 max-w-xl">
                                Juntar → remover páginas → comprimir → PDF/A: encadeie operações e baixe só o resultado
                                final. Um fluxo inteiro conta como 1 operação do seu limite diário.
                            </p>
                        </div>
                        <span className="font-mono-tag text-xs font-bold uppercase px-5 py-3 bg-[#22D3EE] text-black group-hover:bg-black group-hover:text-[#22D3EE] transition-colors self-start md:self-center whitespace-nowrap">
                            Montar fluxo →
                        </span>
                    </div>
                </Link>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                    {TOOLS.map((tool) => (
                        <ToolCard key={tool.slug} tool={tool} />
                    ))}
                </div>
            </section>

            {/* PAINEL DE PROCESSAMENTO */}
            <section className="py-16 bg-white border-y-2 border-black">
                <div className="max-w-6xl mx-auto px-6">
                    <h2 className="font-poster text-3xl text-black mb-8">Painel de processamento seguro</h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {PANELS.map((p) => (
                            <div key={p.label} className="border-2 border-black p-3 bg-[#FAFAF9]">
                                <div className="h-36 relative overflow-hidden">
                                    <img src={p.img} alt={p.alt} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
                                    <span className="absolute bottom-0 left-0 px-3 py-1.5 bg-black font-mono-tag text-xs font-bold text-[#22D3EE]">
                                        {p.label}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* PRIVACIDADE */}
            <section id="privacidade" className="py-20 px-6 max-w-6xl mx-auto">
                <div className="border-2 border-black bg-black text-white p-8 md:p-12">
                    <span className="font-mono-tag text-xs font-bold text-[#22D3EE] uppercase">Garantia de segurança</span>
                    <h2 className="font-poster text-3xl md:text-5xl mt-2">Arquivos deletados em até 60 minutos.</h2>
                    <p className="text-sm text-gray-300 mt-4 max-w-xl">
                        Nenhum documento permanece em nossos servidores. Sem rastreamento de comportamento, sem venda
                        de dados e em total conformidade com a LGPD.{" "}
                        <Link to="/privacidade" className="underline decoration-[#22D3EE] underline-offset-4 hover:text-[#22D3EE]" data-testid="privacy-section-link">
                            Leia a política de privacidade
                        </Link>
                    </p>
                    <div className="mt-8 pt-8 border-t border-gray-800">
                        <h3 className="font-poster text-xl text-white">Depoimentos dos usuários</h3>
                        <p className="font-mono-tag text-xs text-gray-400 mt-2" data-testid="reviews-placeholder">
                            Os primeiros relatos de uso da comunidade brasileira estarão listados neste espaço após o
                            lançamento público.
                        </p>
                    </div>
                </div>
            </section>

            {/* FAQ RESUMO */}
            <section id="duvidas" className="py-16 px-6 max-w-4xl mx-auto border-t-2 border-black">
                <h2 className="font-poster text-3xl text-center text-black mb-8">Perguntas frequentes</h2>
                <div className="space-y-4">
                    {FAQ_HOME.map((item) => (
                        <div key={item.q} className="border-2 border-black p-5 bg-white">
                            <h3 className="font-bold text-black text-sm">{item.q}</h3>
                            <p className="text-xs text-gray-700 mt-1">{item.a}</p>
                        </div>
                    ))}
                </div>
                <div className="text-center mt-8">
                    <Link to="/faq" data-testid="faq-more-link" className="font-mono-tag text-xs font-bold uppercase underline decoration-[#0284C7] decoration-2 underline-offset-4 hover:text-[#0284C7]">
                        Ver todas as perguntas
                    </Link>
                </div>
            </section>
        </main>
    );
}
